//
import { RTable } from '@/components/reusable_components/next'

//
import WhProductDeletedFilters from '@/views/Warehouse/WhProductDeleted/filters'
import WhProductDeletedHeaders from '@/views/Warehouse/WhProductDeleted/headers'
import WhProductDeletedService from '@/services/api/Warehouse/WhProductDeleted'

//
export default {
  components: {
    RTable,
  },
  computed: {

    /**
     * 
     */
    tableProps() {
      return {
        filters: WhProductDeletedFilters.toList(),
        headers: WhProductDeletedHeaders.toList(),
        service: WhProductDeletedService.toList(),
      }
    }
  },
  methods: {

    /**
     * 
     */
    onError(error) {
      this.$toast.error(error.response.data.error || error.response.data.message)
    },

    /**
     * 
     */
    onSuccess(event) {
      this.$toast.success(event.data.message)      
    },

    /**
     * 
     */
    onRestore(event) {
      this.$toast.confirm('¿Confirma la restauración del producto seleccionado?', this.$toaster(this, () => this.toRestore(event.item))) 
    },

    /**
     * 
     */
    toRefresh() {
      this.$refs.table.refresh()
    },

    /**
     * 
     */
    toRestore(whProductDeleted) {
      WhProductDeletedService.restore(whProductDeleted).then(this.onSuccess).then(this.toRefresh).catch(this.onError)
    },
  },
  mounted() {
    this.setTitle('Productos eliminados')
  }
}